import component from './HeatOrCombi.vue';
import { StepCategoryId, StepId } from '~/consts/assistant-steps';
import {
  FormMultipleChoiceValueType,
  StepDefinition,
} from '@/interfaces/step-definition';
import { AssistantStepContext } from '@/interfaces/context';
import { FormFieldType } from '@/consts/input-types';
import { FormFieldGroupId } from '~/consts/assistant-form-field-groups';

export interface HeatOrCombiStepContext extends AssistantStepContext {
  interest: FormMultipleChoiceValueType;
}

/**
 * Entry page for the print/QR campaign: routes into the existing heating or
 * combi assistant. Category ROOT keeps it out of the progress bar, out of the
 * request summary and out of the persisted state - it is a switch, not a
 * question of either assistant.
 */
const config: StepDefinition = {
  component,
  hideSkipMessage: () => true,
  fields: [
    {
      component: {
        columns: 2,
        disableUnselect: true,
        options: [
          {
            value: 'heating',
            image: {
              file: 'img/icon/space-heating-2.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
          {
            value: 'combi',
            image: {
              file: 'img/icon/solar.svg',
              options: {
                height: 50,
                width: 50,
              },
            },
          },
        ],
        singleAnswer: true,
        verticalOptionLayout: true,
      },
      name: 'interest',
      required: true,
      type: FormFieldType.MultipleChoice,
      groupId: FormFieldGroupId.PRODUCT,
    },
  ],
  id: StepId.HEAT_OR_COMBI,
  categoryId: StepCategoryId.ROOT,
};

export default config;
